import {createEvent} from "effector";

export const changeSearchValueEv = createEvent()

export const searchClientsEv = createEvent()

export const resetSearchValueEv = createEvent()

export const resetSearchDataEv = createEvent()
